// extracted by mini-css-extract-plugin
module.exports = {"select":"PhoneInput_select__vF_Hb"};